var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72.03 72.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e6e6e6;stroke:#787e88;stroke-linejoin:round;stroke-width:3.21px;}.cls-2{fill:#fa5a5a;stroke:#c14b50;stroke-width:3.79px;}.cls-2,.cls-3{stroke-miterlimit:10;}.cls-3{fill:none;stroke:#fff;stroke-linecap:round;stroke-width:4px;}.cls-4{font-size:43px;fill:#787e88;font-family:Montserrat-SemiBold, Montserrat;font-weight:700;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "calender") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.9,19H70.13a0,0,0,0,1,0,0v41.7a9.48,9.48,0,0,1-9.48,9.48H11.37A9.48,9.48,0,0,1,1.9,60.66V19A0,0,0,0,1,1.9,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.37,1.9H60.66a9.48,9.48,0,0,1,9.48,9.48V19a0,0,0,0,1,0,0H1.9a0,0,0,0,1,0,0V11.37A9.48,9.48,0,0,1,11.37,1.9Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 18.96,
    y1: 15.64,
    x2: 18.96,
    y2: 23.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 36.01,
    y1: 15.64,
    x2: 36.01,
    y2: 23.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 53.07,
    y1: 15.64,
    x2: 53.07,
    y2: 23.58
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(17.41 59.8)"
  }, "31")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.4360048f24ff3bb9a9fc876a907fc46e.svg";
export { ForwardRef as ReactComponent };